import { Container, Item } from 'Components/Grid';
import colors from '../../../config/theme/colors';
import { formatPartialDate } from 'Utility/date';
import { partialDateFromDate } from 'neuro-utils';
import Icon from '../Icon';
import HistoryRowControls from 'Components/HistoryRowControls';

const FilePreviewBox = ({
  name,
  date,
  thumbnail,
  showArrow = true,
  arrow = 'openInNew',
  onClick,
  file,
  controls,
}: IFilePreviewBox) => {
  return (
    <div
      style={{
        borderRadius: '0.2rem',
        border: '0.1rem solid ' + colors.mediumGray,
        padding: '1rem',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <Container alignItems={'center'}>
        <Item
          xs={showArrow || controls ? 10 : 12}
          onClick={onClick ?? undefined}
          style={{
            cursor: 'pointer',
          }}
        >
          {thumbnail && <></> /* thumbnail here when they are available */}
          {name && (
            <div
              style={{
                fontSize: '1.4rem',
                fontWeight: 600,
                color: colors.darkGray,
                boxSizing: 'border-box',
                width: '100%',
                maxWidth: 'calc(100%)',
              }}
              className="ellipsis"
            >
              {name}
            </div>
          )}
          <div style={{ fontSize: '1.4rem', color: colors.darkGray }}>
            {date ? formatPartialDate(partialDateFromDate(new Date(date))) : 'No date'}
          </div>
        </Item>
        {showArrow || controls ? (
          <Item xs={true}>
            <Container justifyContent={'flex-end'}>
              {showArrow && (
                <Item
                  xs={12}
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginRight: '0.25rem',
                    ...(showArrow && controls ? { marginBottom: '0.5rem' } : {}),
                  }}
                >
                  <Icon button icon={arrow} color={'gray'} size={2.0} onClick={onClick ?? undefined} />
                </Item>
              )}
              {controls && (
                <HistoryRowControls
                  document={file}
                  startEdit={() => controls.edit.onClick}
                  hideButton
                  showEditInMenu
                  noMenuIconPadding
                />
              )}
            </Container>
          </Item>
        ) : (
          <></>
        )}
      </Container>
    </div>
  );
};

interface IFilePreviewBox {
  name?: string;
  date?: string;
  thumbnail?: React.JSX.Element;
  showArrow?: boolean;
  arrow?: 'openInNew' | 'maximize';
  onClick?: (e: React.MouseEvent) => void;
  file: TFile;
  controls?: { edit: { onClick: () => void } };
}

export default FilePreviewBox;
